import { render } from "./AccountCreationPage.vue?vue&type=template&id=ace02b28&scoped=true"
import script from "./AccountCreationPage.vue?vue&type=script&lang=js"
export * from "./AccountCreationPage.vue?vue&type=script&lang=js"

import "./AccountCreationPage.vue?vue&type=style&index=0&id=ace02b28&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ace02b28"]])

export default __exports__